import React from 'react';
import { ScrollReveal } from '../ui/ScrollReveal';
import { CTAButton } from '../ui/CTAButton';
import { CheckCircleIcon, DownloadIcon, InfinityIcon, FileTextIcon, GiftIcon } from 'lucide-react';
import { useCurrencyByIP } from '../../hooks/useCurrencyByIP';
export function OfferStackSection() {
  const {
    price,
    isLoading
  } = useCurrencyByIP();
  return <section className="w-full py-20 md:py-32 px-4 md:px-5" data-id="element-195">
      <div className="max-w-3xl mx-auto" data-id="element-196">
        <ScrollReveal data-id="element-197">
          <div className="text-center mb-4" data-id="element-198">
            <div className="inline-flex items-center gap-2 bg-accent/10 border border-accent/20 rounded-full px-3.5 py-1.5 mb-5" data-id="element-199">
              <GiftIcon className="w-3.5 h-3.5 text-accent" data-id="element-200" />
              <span className="text-xs font-bold text-accent uppercase tracking-wider" data-id="element-201">
                Oferta completa
              </span>
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight text-center mb-4" data-id="element-202">
            Todo lo que recibes{' '}
            <span className="font-serif-italic text-accent-light" style={{
            textShadow: '0 0 20px rgba(251,191,36,0.35)'
          }} data-id="element-203">
              hoy
            </span>
          </h2>
          <p className="text-lg text-neutral-400 text-center mb-12 max-w-xl mx-auto" data-id="element-204">
            Un arsenal completo por menos de lo que cuesta un café con pastel.
          </p>
        </ScrollReveal>

        {/* Value stack card */}
        <ScrollReveal delay={0.1} data-id="element-205">
          <div className="relative bg-surface border border-accent/20 rounded-3xl p-6 md:p-10 overflow-hidden" data-id="element-206">
            {/* Background glow */}
            <div className="absolute inset-0 pointer-events-none" style={{
            background: 'radial-gradient(ellipse at top center, rgba(255,107,0,0.05) 0%, transparent 60%)'
          }} data-id="element-207" />

            <div className="relative space-y-4" data-id="element-208">
              {/* Item 1 */}
              <div className="flex items-start justify-between gap-4 pb-4 border-b border-border/50" data-id="element-209">
                <div className="flex gap-3 items-start" data-id="element-210">
                  <CheckCircleIcon className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-211" />
                  <div data-id="element-212">
                    <p className="text-white font-bold" data-id="element-213">
                      200 ganchos virales en Español MX
                    </p>
                    <p className="text-sm text-neutral-500" data-id="element-214">
                      Listos para copiar y ajustar a tu nicho
                    </p>
                  </div>
                </div>
                <span className="text-sm text-neutral-500 line-through flex-shrink-0" data-id="element-215">
                  $47
                </span>
              </div>

              {/* Item 2 */}
              <div className="flex items-start justify-between gap-4 pb-4 border-b border-border/50" data-id="element-216">
                <div className="flex gap-3 items-start" data-id="element-217">
                  <CheckCircleIcon className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-218" />
                  <div data-id="element-219">
                    <p className="text-white font-bold" data-id="element-220">
                      Plantillas de apertura listas para usar
                    </p>
                    <p className="text-sm text-neutral-500" data-id="element-221">
                      Para cuando te quedas en blanco
                    </p>
                  </div>
                </div>
                <span className="text-sm text-neutral-500 line-through flex-shrink-0" data-id="element-222">
                  $27
                </span>
              </div>

              {/* Item 3 */}
              <div className="flex items-start justify-between gap-4 pb-4 border-b border-border/50" data-id="element-223">
                <div className="flex gap-3 items-start" data-id="element-224">
                  <CheckCircleIcon className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-225" />
                  <div data-id="element-226">
                    <p className="text-white font-bold" data-id="element-227">
                      Fórmula 1–3–1 + Mini guía
                    </p>
                    <p className="text-sm text-neutral-500" data-id="element-228">
                      El sistema para fabricar ganchos que funcionan
                    </p>
                  </div>
                </div>
                <span className="text-sm text-neutral-500 line-through flex-shrink-0" data-id="element-229">
                  $17
                </span>
              </div>

              {/* Item 4 */}
              <div className="flex items-start justify-between gap-4 pb-4 border-b border-border/50" data-id="element-230">
                <div className="flex gap-3 items-start" data-id="element-231">
                  <CheckCircleIcon className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-232" />
                  <div data-id="element-233">
                    <p className="text-white font-bold" data-id="element-234">
                      Selector rápido por tipo de Reel
                    </p>
                    <p className="text-sm text-neutral-500" data-id="element-235">
                      Elige el gancho perfecto en segundos
                    </p>
                  </div>
                </div>
                <span className="text-sm text-neutral-500 line-through flex-shrink-0" data-id="element-236">
                  $12
                </span>
              </div>

              {/* Item 5 */}
              <div className="flex items-start justify-between gap-4 pb-4 border-b border-border/50" data-id="element-237">
                <div className="flex gap-3 items-start" data-id="element-238">
                  <CheckCircleIcon className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-239" />
                  <div data-id="element-240">
                    <p className="text-white font-bold" data-id="element-241">
                      Checklist del primer segundo
                    </p>
                    <p className="text-sm text-neutral-500" data-id="element-242">
                      Visual + texto + ritmo
                    </p>
                  </div>
                </div>
                <span className="text-sm text-neutral-500 line-through flex-shrink-0" data-id="element-243">
                  $9
                </span>
              </div>

              {/* Item 6 */}
              <div className="flex items-start justify-between gap-4 pb-4 border-b border-border/50" data-id="element-244">
                <div className="flex gap-3 items-start" data-id="element-245">
                  <CheckCircleIcon className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-246" />
                  <div data-id="element-247">
                    <p className="text-white font-bold" data-id="element-248">
                      Ejemplos Antes/Después
                    </p>
                    <p className="text-sm text-neutral-500" data-id="element-249">
                      Ganchos débiles reescritos a ganchos que detienen
                    </p>
                  </div>
                </div>
                <span className="text-sm text-neutral-500 line-through flex-shrink-0" data-id="element-250">
                  $7
                </span>
              </div>

              {/* Total */}
              <div className="pt-4 space-y-3" data-id="element-251">
                <div className="flex items-center justify-between" data-id="element-252">
                  <span className="text-neutral-400 font-semibold" data-id="element-253">
                    Valor total:
                  </span>
                  <span className="text-lg text-neutral-500 line-through" data-id="element-254">
                    $119 USD
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-255">
                  <span className="text-neutral-500 text-sm" data-id="element-256">
                    Precio normal:
                  </span>
                  <span className="text-base text-neutral-500 line-through" data-id="element-257">
                    $29 USD
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-258">
                  <div className="flex items-center gap-2" data-id="element-259">
                    <span className="text-white font-bold text-lg" data-id="element-260">
                      🔥 Super Promo:
                    </span>
                  </div>
                  <span className={`text-3xl md:text-4xl font-extrabold text-accent transition-opacity duration-300 ${isLoading ? 'opacity-50' : 'opacity-100'}`} data-id="element-261">
                    {price}
                  </span>
                </div>
                <p className="text-xs text-amber-400/70 font-medium text-right" data-id="element-262">
                  Solo por esta semana
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="relative mt-8 flex justify-center" data-id="element-263">
              <CTAButton className="w-full" data-id="element-264">
                Acceder a los 200 ganchos — {price}
              </CTAButton>
            </div>

            {/* Trust badges */}
            <div className="relative mt-6 flex flex-wrap items-center justify-center gap-4 md:gap-6" data-id="element-265">
              <div className="flex items-center gap-1.5 text-neutral-500 text-xs" data-id="element-266">
                <DownloadIcon className="w-3.5 h-3.5" data-id="element-267" />
                <span data-id="element-268">Descarga inmediata</span>
              </div>
              <div className="flex items-center gap-1.5 text-neutral-500 text-xs" data-id="element-269">
                <InfinityIcon className="w-3.5 h-3.5" data-id="element-270" />
                <span data-id="element-271">Acceso de por vida</span>
              </div>
              <div className="flex items-center gap-1.5 text-neutral-500 text-xs" data-id="element-272">
                <FileTextIcon className="w-3.5 h-3.5" data-id="element-273" />
                <span data-id="element-274">PDF listo para usar</span>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}